import React from 'react'
import classnames from 'classnames'
import styles from './MaskedIcon.module.css'

export interface MaskedIconProps {
  src: string
  size?: number
  className?: string
}

const MaskedIcon: React.FC<MaskedIconProps> = ({
  src,
  size = 14,
  className
}) => (
  <span
    className={classnames(styles.icon, className)}
    style={{
      width: size,
      height: size,
      WebkitMaskImage: `url(${src})`,
      maskImage: `url(${src})`
    }}
    aria-hidden="true"
  />
)

export default MaskedIcon
